import React from 'react';
import {Tag, TagSize, TagVariant} from '../../../components/tag';
import {JobApplicationStatus} from '../../../models/job-application';

interface ApplicantStatusBadgeProps {
  status: JobApplicationStatus;
  isNew?: boolean;
}

export const ApplicantStatusBadge: React.FC<ApplicantStatusBadgeProps> = ({status, isNew}) => {
  if (isNew && status === JobApplicationStatus.APPLIED) {
    return (
      <div className="absolute top-3 right-3">
        <Tag variant={TagVariant.Primary} size={TagSize.SM} className="uppercase tracking-wide">
          New
        </Tag>
      </div>
    );
  }

  switch (status) {
    case JobApplicationStatus.APPLIED:
      return (
        <div className="absolute top-3 right-3">
          <Tag variant={TagVariant.Default} size={TagSize.SM} className="uppercase tracking-wide">
            Applied
          </Tag>
        </div>
      );
    case JobApplicationStatus.INVITED:
      return (
        <div className="absolute top-3 right-3">
          <Tag variant={TagVariant.Secondary} size={TagSize.SM} className="uppercase tracking-wide">
            Invited
          </Tag>
        </div>
      );
    case JobApplicationStatus.ACCEPTED:
      return (
        <div className="absolute top-3 right-3">
          <Tag variant={TagVariant.Success} size={TagSize.SM} className="uppercase tracking-wide">
            Shortlisted
          </Tag>
        </div>
      );
    case JobApplicationStatus.REJECTED:
      return (
        <div className="absolute top-3 right-3">
          <Tag variant={TagVariant.Error} size={TagSize.SM} className="uppercase tracking-wide">
            Rejected
          </Tag>
        </div>
      );
    case JobApplicationStatus.WITHDRAWN:
      return (
        <div className="absolute top-3 right-3">
          <Tag variant={TagVariant.Warning} size={TagSize.SM} className="uppercase tracking-wide">
            Withdrawn
          </Tag>
        </div>
      );
    default:
      return null;
  }
};
